import { render, staticRenderFns } from "./livevideo.vue?vue&type=template&id=37d22e7e&scoped=true"
import script from "./livevideo.vue?vue&type=script&lang=js"
export * from "./livevideo.vue?vue&type=script&lang=js"
import style0 from "./livevideo.vue?vue&type=style&index=0&id=37d22e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d22e7e",
  null
  
)

export default component.exports